module.exports = __webpack_public_path__ + "static/media/Poweredby_logo@3x.78d4c2d9.png";